module.exports = __webpack_public_path__ + "static/img/group-9.cebc91f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/group-9.svg
// module id = GNj7
// module chunks = 1